import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Col, Container, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { getContent } from '../../redux/actions/contentActions';
class Footer extends Component {
    state = {}
    componentDidMount(){
        this.props.getContent();
    }
    render() {
        var {content}=this.props;
        return (<>
            <footer id="bottom-footer">
                <Container>
                    <Row>
                        <Col lg="3">
                            <div className="d-flex flex-column font-2">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="logo-circle"></div>
                                    <h3>Logo</h3>
                                </div>
                                <h6>@2020 ClueRush.com</h6>
                                <small className="text-lightpurple-1">{content&&content.length?content.find(con=>con.type=="footer")?content.find(con=>con.type=="footer").description:null:null}</small>
                            </div>
                        </Col>
                        <Col lg="3">
                            <Nav vertical>
                                <NavItem>
                                    <NavLink tag={Link} to="/games">Games</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/gallery">Gallery</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/team-building">Team Building Activities</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/faq">FAQ</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/contact">Contact Us</NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col lg="3">
                            <Nav vertical>
                                <NavItem>
                                    <NavLink tag={Link} to="/privacy-policy">Privacy Policy</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/terms">Terms and Conditions</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/refund-policy">Refund Policy</NavLink>

                                </NavItem>
                            </Nav>
                        </Col>
                        <Col lg="3">
                            <div className="d-flex h-100 align-items-center justify-content-end">
                                <Nav style={{fontSize:"x-large"}}>
                                    <NavItem>
                                        <NavLink href="#"><i className="fa fa-play"></i></NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink href="#"><i className="fa fa-apple"></i></NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                        </Col>
                    </Row>
                    <div className="d-flex">
                        <div className="ms-auto">
                            <Nav className="social-link">
                                <NavItem>
                                    <NavLink href="#"><i className="fab fa-facebook-f"></i></NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#"><i className="fab fa-twitter"></i></NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#"><i className="fab fa-instagram"></i></NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#"><i className="fab fa-youtube"></i></NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </div>
                </Container>
            </footer>
        </>);
    }
}
const mapStateToProps = (state) => {
  return {
    // auth: state.auth,
    content: state.content.content,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getContent: () => dispatch(getContent()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Footer);
